import { Controller } from "@hotwired/stimulus"

// Reveals a focus ring only when focus arrives via the keyboard (e.g. Tab),
// not via mouse/touch. Browsers force :focus-visible on text inputs even for
// pointer clicks, so CSS alone can't tell the two apart — we track the input
// modality ourselves.
let usingKeyboard = false

document.addEventListener("keydown", (event) => {
  if (event.key === "Tab") usingKeyboard = true
}, true)

document.addEventListener("pointerdown", () => {
  usingKeyboard = false
}, true)

export default class extends Controller {
  static classes = ["focus"]

  connect() {
    this.element.addEventListener("focusin", this.#show)
    this.element.addEventListener("focusout", this.#hide)
  }

  disconnect() {
    this.element.removeEventListener("focusin", this.#show)
    this.element.removeEventListener("focusout", this.#hide)
  }

  #show = () => {
    if (usingKeyboard) this.element.classList.add(...this.focusClasses)
  }

  #hide = () => {
    this.element.classList.remove(...this.focusClasses)
  }
}
